<template>
    <ion-menu menu-id="notifications-menu" content-id="main-content" side="end" type="overlay"
        :swipe-gesture="true" @ionWillOpen="refresh()">
        <NcHeader>
            <template #start>
                <NcButton fill="clear" color="medium" icon @click="close()">
                    <mdicon name="chevron-right" />
                </NcButton>
            </template>
            <template #title>
                <span class="nc-notifmenu__title">
                    Notificaties
                    <span v-if="unreadCount > 0" class="nc-notifmenu__count">{{ unreadCount }}</span>
                </span>
            </template>
            <template #end>
                <NcButton fill="clear" color="primary" icon :disabled="unreadCount === 0" @click="markAllRead()">
                    <mdicon name="check-all" />
                </NcButton>
                <NcButton fill="clear" color="danger" icon :disabled="notifications.length === 0"
                    @click="confirmDeleteAll()">
                    <mdicon name="trash-can-outline" />
                </NcButton>
            </template>
        </NcHeader>
        <NcContent>
            <Notifications :notifications="notifications" @navigate="close()" />
        </NcContent>
    </ion-menu>
</template>

<script>
import Notifications from '@/components/Notifications.vue'
import { IonMenu, alertController, menuController } from '@ionic/vue'
import { db } from '@/services/db'
import { liveQuery } from 'dexie'

export default {
    name: 'novacheck-sidemenu',
    components: {
        Notifications,
        IonMenu,
    },
    data() {
        return {
            notifications: [],
            subscription: null,
        }
    },
    computed: {
        unreadCount() {
            return this.notifications.filter(notification => !notification.read_at).length
        },
    },
    created() {
        const observable = liveQuery(() => db.notifications.toArray())

        this.subscription = observable.subscribe({
            next: result => {
                this.notifications = result.sort(
                    (a, b) => new Date(b.created_at) - new Date(a.created_at)
                )
            },
            error: error => console.error(error),
        })
    },
    beforeUnmount() {
        if (this.subscription) this.subscription.unsubscribe()
    },
    methods: {
        refresh() {
            // Haal de laatste notificaties op; de liveQuery werkt de lijst bij.
            this.$requests.get('notifications', '/notifications')
        },
        close() {
            menuController.close('notifications-menu')
        },
        async markAllRead() {
            const read_at = new Date().toISOString()
            const unread = this.notifications.filter(notification => !notification.read_at)

            for (const notification of unread) {
                await this.$requests.patch(
                    'notifications',
                    '/notifications/' + notification.id,
                    { ...notification, read_at }
                )
            }
        },
        async deleteAll() {
            for (const notification of this.notifications) {
                await this.$requests.delete(
                    'notifications',
                    '/notifications/' + notification.id,
                    notification.id
                )
            }
        },
        async confirmDeleteAll() {
            const alert = await alertController.create({
                header: 'Alles verwijderen',
                message: 'Weet je zeker dat je alle notificaties wilt verwijderen?',
                buttons: [
                    {
                        text: 'Annuleren',
                        role: 'cancel',
                    },
                    {
                        text: 'Verwijderen',
                        role: 'destructive',
                        handler: () => this.deleteAll(),
                    },
                ],
            })

            await alert.present()
        },
    },
}
</script>

<style scoped>
.nc-notifmenu__title {
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.nc-notifmenu__count {
    min-width: 18px;
    height: 18px;
    padding: 0 5px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--nc-radius-full);
    background: var(--nc-color-primary);
    color: var(--nc-text-on-primary);
    font-size: 11px;
    font-weight: var(--nc-font-weight-bold);
}
</style>
